import { Box, CheckboxInput } from '@deckee/deck-hand';
import React, { FC } from 'react';
import styled from 'styled-components';
import MarkerCircle from '../../../shared/_deprecated/components/MarkerCircle/MarkerCircle';
import { WaypointLayer } from '../mapSettingsConfig';

interface WaypointRowProps {
  layer: WaypointLayer;
  checked: boolean;
  onToggle: (_layerName: string) => void;
}

/**
 * A label so tapping anywhere on the row drives the checkbox natively. The
 * checkbox is the only thing that changes on select — no row highlight.
 */
const StyledRow = styled(Box).attrs({ as: 'label' })`
  cursor: pointer;
`;

/** One marker type inside a waypoint group. */
const WaypointRow: FC<WaypointRowProps> = ({ layer, checked, onToggle }) => (
  <StyledRow
    display="flex"
    alignItems="center"
    width="100%"
    py={2.5}
    px="1"
    gap={2.5}
  >
    <Box display="flex" flex="0 0 auto">
      <MarkerCircle iconConfig={layer.icon} width={36} height={36} />
    </Box>

    <Box flex="1 1 auto" fontSize="15px" color="black">
      {layer.displayName}
    </Box>

    <CheckboxInput
      name={`map-layer-${layer.layerName}`}
      checked={checked}
      onChange={() => onToggle(layer.layerName)}
    />
  </StyledRow>
);

export default WaypointRow;
